export const DARK_BG = '#0A0520';
export const NOPING_GREEN = '#93FF18';
export const PURPLE = '#2D1B69';
export const DEEP_PURPLE = '#1A0F3F';
export const SILVER = '#C0C0C0';
export const TEXT_LIGHT = '#E5E7EB';
export const MUTED_GRAY = '#929298';
export const CARD_DARK = '#1D2028';

export const EASE_OUT = [0.25, 0.46, 0.45, 0.94] as const;

export const CHAMPIONS = [
  { name: 'Sacy', badge: 'World Champion', game: 'Valorant', accent: '#FF4655', quoteKey: 'champions.sacy_quote' },
  { name: 'coldzera', badge: '2x Best in World', game: 'CS2', accent: '#F5A623', quoteKey: 'champions.coldzera_quote' },
  { name: 'BRTT', badge: '6x Champion', game: 'League of Legends', accent: '#00D8FF', quoteKey: 'champions.brtt_quote' },
] as const;

export const COMMUNITY_STATS_KEYS = [
  { valueKey: 'community.active_gamers_value', labelKey: 'community.active_gamers_label' },
  { valueKey: 'community.countries_value', labelKey: 'community.countries_label' },
  { valueKey: 'community.servers_value', labelKey: 'community.servers_label' },
  { valueKey: 'community.games_supported_value', labelKey: 'community.games_supported_label' },
] as const;

export const ARSENAL_KEYS = [
  { nameKey: 'arsenal.fps_boost_name', taglineKey: 'arsenal.fps_boost_tagline', descKey: 'arsenal.fps_boost_desc', iconPath: 'M13 2L3 14h9l-1 8 10-12h-9l1-8z' },
  { nameKey: 'arsenal.aim_trainer_name', taglineKey: 'arsenal.aim_trainer_tagline', descKey: 'arsenal.aim_trainer_desc', iconPath: 'M12 2a10 10 0 100 20 10 10 0 000-20zm0 4a6 6 0 100 12 6 6 0 000-12zm0 4a2 2 0 100 4 2 2 0 000-4z' },
  { nameKey: 'arsenal.audiopad_name', taglineKey: 'arsenal.audiopad_tagline', descKey: 'arsenal.audiopad_desc', iconPath: 'M3 18v-6a9 9 0 0118 0v6' },
  { nameKey: 'arsenal.replay_x_name', taglineKey: 'arsenal.replay_x_tagline', descKey: 'arsenal.replay_x_desc', iconPath: 'M12 2a10 10 0 100 20 10 10 0 000-20z', secondaryPath: 'M10 8l6 4-6 4V8z' },
  { nameKey: 'arsenal.pro_settings_name', taglineKey: 'arsenal.pro_settings_tagline', descKey: 'arsenal.pro_settings_desc', iconPath: 'M12.22 2h-.44a2 2 0 00-2 2v.18a2 2 0 01-1 1.73l-.43.25a2 2 0 01-2 0l-.15-.08a2 2 0 00-2.73.73l-.22.38a2 2 0 00.73 2.73l.15.1a2 2 0 011 1.72v.51a2 2 0 01-1 1.74l-.15.09a2 2 0 00-.73 2.73l.22.38a2 2 0 002.73.73l.15-.08a2 2 0 012 0l.43.25a2 2 0 011 1.73V20a2 2 0 002 2h.44a2 2 0 002-2v-.18a2 2 0 011-1.73l.43-.25a2 2 0 012 0l.15.08a2 2 0 002.73-.73l.22-.39a2 2 0 00-.73-2.73l-.15-.08a2 2 0 01-1-1.74v-.5a2 2 0 011-1.74l.15-.09a2 2 0 00.73-2.73l-.22-.38a2 2 0 00-2.73-.73l-.15.08a2 2 0 01-2 0l-.43-.25a2 2 0 01-1-1.73V4a2 2 0 00-2-2z', secondaryPath: 'M12 15a3 3 0 100-6 3 3 0 000 6z' },
  { nameKey: 'arsenal.multi_internet_name', taglineKey: 'arsenal.multi_internet_tagline', descKey: 'arsenal.multi_internet_desc', iconPath: 'M5 12.55a11 11 0 0114.08 0M1.42 9a16 16 0 0121.16 0M8.53 16.11a6 6 0 016.95 0', secondaryPath: 'M12 20h.01' },
] as const;

export const FAQ_KEYS = [
  { ruleKey: 'faq.rule1_label', qKey: 'faq.rule1_q', aKey: 'faq.rule1_a' },
  { ruleKey: 'faq.rule2_label', qKey: 'faq.rule2_q', aKey: 'faq.rule2_a' },
  { ruleKey: 'faq.rule3_label', qKey: 'faq.rule3_q', aKey: 'faq.rule3_a' },
  { ruleKey: 'faq.rule4_label', qKey: 'faq.rule4_q', aKey: 'faq.rule4_a' },
] as const;
